import MetaDataHelper, { declareEntity } from '../fw/MetaDataHelper.ts';
import { hasSnapshotTestDeveloperPermission } from '../util/SnapshotTestPermission';

export default declareEntity({
    entity: 'testRuns',
    graphQL: 'TestRun',
    name: 'Test Run',
    storageType: 'testcase',
    isPublic: false,
    userEditable: false,
    userCreatable: false,
    userDeletable: false,
    permissionFunc: (action, permissionObject) => {
        return hasSnapshotTestDeveloperPermission(permissionObject);
    },
    fields: (types) => { return {
        id: { name: 'ID', type: 'ID', primaryKey: true, required: true, isPublic: true },
        testInvocation_id: { type: 'relation', to: () => types['testInvocations'], parent: true },
        organisation_id: { type: 'relation', to: () => types['organisations'] },
        status: { type: 'string', isPublic: true },
        error: { type: 'text', isPublic: true },
        duration: { type: 'int', isPublic: true },
        createdAt: { type: 'datetime', isPublic: true },
        expiresIn: { type: 'int', isPublic: true },
        lastHeartbeatAt: { type: 'datetime' },
        actualOutput: { type: 'object', isPublic: true },
        computedDiff: { type: 'object', controllerFn: 'getComputedDiff', isPublic: true },
    }; }
});
